import { gql } from "apollo-angular";
import { NAVLINKS } from "./menu-link";
import { LINK_FIELDS } from "./link";

export const SCF = gql`
  fragment SCF on SubmenuCallout {
    backgroundColor {
      color
    }
    label
    hTag
    value
    linksCollection(limit:6) {
      items {
        ... NAVLINKS
        ... LINK_FIELDS
      }
    }
  }
${NAVLINKS}
${LINK_FIELDS}`;
